import React , { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom'
import axios from "axios"; 
import diamond from "../Shared/Lotties/red-diamond-lottie.json";
import { Player } from "@lottiefiles/react-lottie-player";

const Upgrade = ({}) => {
  const history = useHistory();
  const match = useRouteMatch();
  const [disabled, setDisabled] = useState(false);

  const fetchCheckoutUrl = () => {
    setDisabled(true);
    axios.post(`/api/o/${match.params.organization_id}/stripe_checkout?redirect_path=${window.location.href}&tolt_referral=${window.tolt_referral}`)
    .then(function(response){
      // console.log(response);
      window.location.replace(response.data.payment_url);
      refetchData();
    })
    .catch(function(error){
      console.log(error)
      notice("An error occured")
    })
    .then(function () {
      setDisabled(false)
    });
  }

  return(
    <React.Fragment>
      <div className="row no-margin">
        <div>
          <Player 
            style={{width: "200px", margin: "auto"}} 
            mode="normal" 
            autoplay={true}
            loop={true}
            keepLastFrame={false}
            src={diamond} 
          />
        </div>

        <div className="display-flex flex-column align-items-center" style={{maxWidth: "450px", margin: "auto"}}>
          <h3 className="mt-0">Upgrade required</h3>
          <p className="text-center mt-10">Join the thousands of agencies by unlocking the full potential of Queue for your agency.</p>

          <div className="text-center width-100-percent" style={{marginTop: 30, marginBottom: 30}}>
            <button disabled={disabled} className="btn btn-primary btn-block width-100-percent" onClick={() => fetchCheckoutUrl()}>Upgrade Now</button>
            <p className="opacity-6 font-12 mt-15">Cancel anytime. <a className="color-blue" onClick={() => Intercom('show')}>Chat with support</a> for questions. <a href="https://www.usequeue.com/pricing" target="_blank" className="color-blue">Pricing info</a>.</p>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}

export default Upgrade;